<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4 class="card-title">General Managers</h4>
          </div>
  <div class="card-body">
  <form [formGroup]="AddGMForm">
    <div class="row">
      <div class="col-md-6">
        <mat-form-field class="example-full-width">
          <input matInput placeholder="Name" 
          formControlName="GMName"  >
          <!-- <mat-error *ngIf="BranchName.hasError('required')">
            Company Name is <strong>required</strong>
          </mat-error> -->
        </mat-form-field>

      </div>
      <div class="col-md-6">
        <mat-form-field class="example-full-width">
          <input matInput placeholder="Email" type="email"
          formControlName="Email" appLowercaseInput >
          <!-- <mat-error *ngIf="Address.hasError('required')">
            Username is <strong>required</strong>
          </mat-error> -->
        </mat-form-field>

      </div>

      <div class="col-md-6 mt-3">
        <div class="form-group"
        [style.border]="fc.Branchs.touched ? (fc.Branchs.invalid ? '1px solid #dc3545 !important' : (fc.Branchs.valid && fc.Branchs.touched ? '1px solid #28a745' : 'none')) : 'none'"
        >
          <label>Branches </label>
          <ng-select  class="form-control" [items]="AllBranchs" 
          [multiple]="true"
          bindLabel="name" 
          bindValue="id" 
          formControlName="Branchs"  
          >
        </ng-select>
        </div>
    
        <!-- <mat-form-field>
       
        </mat-form-field> -->
       

         <!-- <mat-form-field>
          <mat-label>Branchs</mat-label>
          <mat-select  matNativeControl formControlName="Branchs" 
               multiple>
              <mat-option  disabled>choose from items</mat-option >
              <mat-option  *ngFor="let item of AllBranchs; let i = index" [value]="item.name">
                  {{item.name}}</mat-option >
          </mat-select >
      </mat-form-field> -->
          <!-- <input matInput placeholder="Email" type="email"
          formControlName="Email"  > -->
          <!-- <ng-multiselect-dropdown
          formControlName="Branchs"
          [placeholder]="'Select Branchs'"
          [settings]="dropdownSettings"
          [data]="AllBranchs"
        >
        </ng-multiselect-dropdown> -->


      </div>
      
    </div>
    <button mat-raised-button type="submit" *ngIf="!update" class="btn primary pull-right" [disabled]="AddGMForm.invalid"  (click)="addGM()">Add GM</button>
                <button mat-raised-button type="submit" *ngIf="update" class="btn primary pull-right"  (click)="addGM()">Save</button>
                <div class="clearfix"></div>
  </form>
  <!-- <mat-form-field class="mt-5">
    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
  </mat-form-field> -->
<br>
  <!-- <table mat-table [dataSource]="Gms" class="mat-elevation-z8">

    <ng-container matColumnDef="Name">
      <th mat-header-cell *matHeaderCellDef> GM Name </th>
      <td mat-cell *matCellDef="let element"> {{element.name}} </td>
    </ng-container>

    <ng-container matColumnDef="Email">
      <th mat-header-cell *matHeaderCellDef> Email </th>
      <td mat-cell *matCellDef="let element"> {{element.email}} </td>
    </ng-container>

   
    <ng-container matColumnDef="action" >
      <th mat-header-cell *matHeaderCellDef> Action </th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button  *ngIf="UserInfo.role == 'admin' ||UserInfo.role == 'cluster'|| UserInfo.role == 'ceo' " (click)="Edit(element)"><i class="material-icons">
            edit
          </i></button>
        <button mat-raised-button *ngIf="UserInfo.role == 'admin' ||UserInfo.role == 'cluster'|| UserInfo.role == 'ceo' " (click)="DeleteGm(element)"><i class="material-icons">
            delete
          </i></button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table> -->
  <div class="table-responsive">
    <table mat-table [dataSource]="Gms" class="mat-elevation-z8 mt-3 table">
  
      <!-- GM Name Column -->
      <ng-container matColumnDef="Name">
        <th mat-header-cell *matHeaderCellDef> GM Name </th>
        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
      </ng-container>
  
      <!-- Email Column -->
      <ng-container matColumnDef="Email">
        <th mat-header-cell *matHeaderCellDef> Email </th>
        <td mat-cell *matCellDef="let element"> {{element.email}} </td>
      </ng-container>
  
      <!-- Action Column -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> Action </th>
        <td mat-cell *matCellDef="let element">
          <button mat-raised-button *ngIf="UserInfo.role == 'admin' || UserInfo.role == 'cluster' || UserInfo.role == 'ceo'" (click)="Edit(element)">
            <i class="material-icons">edit</i>
          </button>
          <button mat-raised-button *ngIf="UserInfo.role == 'admin' || UserInfo.role == 'cluster' || UserInfo.role == 'ceo'" (click)="DeleteGm(element)">
            <i class="material-icons">delete</i>
          </button>
        </td>
      </ng-container>
  
      <!-- Table rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  
    </table>
  </div>
  
</div>
        </div>
      </div>
    </div>
  </div>

</div>



